export default __webpack_public_path__ + "assets/home-4--home-house-roof-shelter.png";